import { message, Modal } from 'antd';
import log from 'loglevel';
import { ReactNode } from 'react';
import { translations } from '../config/translations';

const { confirm } = Modal;

export const showSuccess = (msg: string) => {
    message.success(msg);
};

/**
 * Callers pass `ApiException.response`, the raw body. Handler errors arrive as plain text, but
 * FluentValidation failures arrive as a ProblemDetails JSON document; show its messages, not the JSON.
 */
const readableApiMessage = (body: string): string => {
    if (!body.trim().startsWith('{')) return body;

    try {
        const problem = JSON.parse(body);
        const messages = problem?.errors
            ? Object.values(problem.errors as Record<string, string[]>).flat()
            : [];

        return messages.length ? messages.join(' ') : problem?.title || body;
    } catch {
        return body;
    }
};

export const showError = (msg: any) => {
    if (!msg) {
        log.error('Error with passing arguments, no message to be logged!');
    }
    log.error(msg);
    if (typeof msg === 'string') {
        message.error(readableApiMessage(msg));
    } else if (msg.message) {
        message.error(msg.message);
    } else {
        message.error('Unknown error occured. Please contact developers.');
    }
};

export const showConfirm = (
    onConfirm: () => void,
    title?: string,
    confirmButtonText?: string,
    isDanger?: boolean,
    content?: ReactNode
) => {
    confirm({
        title: title || translations.general.confirmMessage,
        onOk: () => onConfirm(),
        okText:
            confirmButtonText ||
            (isDanger ? translations.general.delete : translations.general.confirm),
        okButtonProps: { danger: isDanger },
        cancelText: translations.general.cancel,
        content,
    });
};
